// Components
import { Button, CommandButton, FooterMenu, Loading } from "components";
import { InputSection, Journal } from "./components";

// Third-Party Libraries
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";

// Types
import type { DataType } from "./types";

// Utils
import { useApi, useToggle } from "utils";
import { useDetail } from "./utils";

export default function EditRecordReject(): JSX.Element {
  // Hooks
  const { id } = useParams();
  const { data, isLoading } = useDetail(id!);

  if (isLoading || !data) {
    return <Loading loading={isLoading} />;
  }

  return (
    <div className="container my-5 flex flex-col gap-3">
      <InputSection data={data} />

      <section className="flex flex-wrap gap-3">
        <Link to={`/purchase/transaction/received-reject/${id}`}>
          <Button color="primary">RECEIVE ITEM</Button>
        </Link>

        <Link to={`/purchase/transaction/received-reject-money/${id}`}>
          <Button color="primary">RECEIVE MONEY</Button>
        </Link>

        <Link to={`/purchase/transaction/received-reject-adjustment/${id}`}>
          <Button color="primary">ADJUSTMENT</Button>
        </Link>
      </section>

      <FooterMenu
        hasCancelButton
        attachment={{ actiontype: "attachment" }}
        delete={{ actiontype: "delete" }}
        // journal={{ actiontype: "journal" }}
        customElement={{
          save: <Save data={data} />,
          journal:<Journal data={data}/>
        }}
      />
    </div>
  );
}

function Save(params: { data: DataType }) {
  // Vars
  const { datareject, detailreject } = params.data;

  // Hooks
  const api = useApi();
  const isLoading = useToggle(false);
  const navigate = useNavigate();

  // Functions
  const onSubmit = () => {
    isLoading.setActive(true);

    toast
      .promise(
        api.post("/proreject/add", {
          bill_id: datareject.bill_id,
          trx_code: datareject.trx_code,
          vendor_id: datareject.vendor_id,
          payment_term_vendor_id: datareject.payment_term_vendor_id,
          location_id: datareject.location_id,
          address: datareject.address,
          memo: datareject.memo,
          transaction_date: datareject.transaction_date,
          referensi: datareject.referensi,
          prorejectdetail: detailreject.map((item) => {
            return {
              quantity_reject: item.quantity_reject,
              quantity_unit: item.quantity_unit,
              product_id: item.product_id,
              price_reject: item.price_reject,
              discount: item.discount,
              total: item.total,
              tax_id: item.tax_id,
              tax_rate: item.tax_rate,
              total_tax_paid: (item.total * item.tax_rate) / 100,
            };
          }),
        }),
        {
          loading: "Saving Rejected Record...",
          success: (res) => res.data.message,
          error: (err) => err.response.data?.message ?? err.response.message,
        }
      )
      .then(() => {
        navigate(-1);
      })
      .catch(() => {})
      .finally(() => {
        isLoading.setActive(false);
      });
  };

  return (
    <CommandButton
      actiontype="save"
      loading={isLoading.isActive ? "true" : undefined}
      onClick={onSubmit}
    />
  );
}


